// extracted by mini-css-extract-plugin
export default {"infoTopic":"Policy_infoTopic__G6z5l","container":"Policy_container__i2Nyr"};